import React, { useState } from 'react';
import { GamesHeader } from '../components/ui/games/games-header';
import { StatCards } from '../components/ui/games/stat-cards';
import { LeaderboardSection } from '../components/ui/games/leaderboard-section';
import { subjectsgamecard } from '../lib/games-data';
import SubjectCard from '../components/ui/games/subject-card';
import GameSelectionModal from '../components/ui/games/subject-game-modal';
import ProtectedRoute from '../components/ProtectedRoute';
import { Sidebar } from '../components/ui/sidebar';
import { UniversalSearch } from '../components/ui/universal-search';

function GamesPage() {
  const [activeSubject, setActiveSubject] = useState(null);

  return (
    <ProtectedRoute>
      <div className="flex min-h-screen bg-slate-200">
        <div className="hidden lg:block">
          <Sidebar />
          <UniversalSearch />
        </div>

        <main className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-6 lg:p-8 space-y-6 lg:space-y-8 lg:ml-64">
          <GamesHeader />
          <StatCards />

          <div className="grid grid-cols-12 gap-4 sm:gap-6 lg:gap-8">
            <div className="col-span-12 lg:col-span-8 space-y-6 lg:space-y-8">
              <section>
                <div className="flex items-center justify-between mb-4 lg:mb-6">
                  <h3 className="text-xl sm:text-2xl font-bold text-slate-800">Subjects</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  {subjectsgamecard.map((subject) => (
                    <SubjectCard
                      key={subject.id}
                      subject={subject}
                      onPlay={setActiveSubject}
                    />
                  ))}
                </div>
              </section>
            </div>

            <div className="col-span-12 lg:col-span-4 space-y-6 lg:space-y-8">
              <LeaderboardSection />
            </div>
          </div>
        </main>

        {/* Single modal instance shared across all cards */}
        {activeSubject && (
          <GameSelectionModal
            isOpen={true}
            onClose={() => setActiveSubject(null)}
            subjectTitle={activeSubject.title}
            subjectId={activeSubject.id}
          />
        )}
      </div>
    </ProtectedRoute>
  );
}

export default GamesPage;
